import { z } from 'zod';

export const GenerateTemplateStatusEnum = z.enum(['idle', 'inProgress']);

export type GenerateTemplateStatus = z.infer<typeof GenerateTemplateStatusEnum>;
